import React from "react";
import PropTypes from "prop-types";
import PlanTypeItem from "./PlanTypeItem";
import {PromotionStyle} from "./PlanTypeStyle";
import FilterItems from "../filterItems/FilterItems";

const PlanType = (props) => {
    return (
        <>
            <div className="customFilter d-none d-lg-block">
                {props.planType && props.planType.length > 0 && (<p className="filter-heading">Plan type</p>)}
                {props?.planType?.map((item, index) => (
                    <PlanTypeItem key={`plan-type-${item.id}-${index}`} plantype={item}
                                  filteredPlanType={(props.filteredPlanType) ? props.filteredPlanType : []}
                                  plantypeClickHandler={(flag) => props.handlePlanTypeSelect(flag, item)}/>
                ))}
            </div>
            <FilterItems heading="Plan Type" handleClick={props.plan}
                         id={props?.displayPlanType == true && props?.filteredPlanType?.length ? `filtered_brands_${props?.filteredPlanType}` : null}
                         renderFun={props?.filteredPlanType?.map(brand => brand.label).join(", ")}
            />
            <style jsx>{PromotionStyle}</style>
        </>
    );
};

PlanType.propTypes = {
    plantype: PropTypes.array,
    plan: PropTypes.func,
    filteredPromotions: PropTypes.string,
    handlePromotionSelect: PropTypes.func,
    planType: PropTypes.array,
    filteredPlanType: PropTypes.array,
    handlePlanTypeSelect: PropTypes.func,
    displayPlanType: PropTypes.bool,
};

export default PlanType;
